import React from 'react';
import PropTypes from 'prop-types';
import styles from './BuildingPriceTable.module.css';
import Label from '../../EntToEndUI/Label/Label';
import Button from '../../Buttons/Button/Button';
import { useScroll } from '../../../context/ScrollContext';

const BuildingPriceTable = ({ data, title, subtitle, warning, onWidthChange, selectedWidth, infoText, buttonText, buttonLink}) => {
  // Проверяем, что у нас есть данные
  const { scrollTo } = useScroll();

  const handleOrderClick = () => {
    console.log('Нажата кнопка заказа в баннере');
    scrollTo('requestForm');
  };
  if (!data || !data.rows || !data.columns) return null;

  return (
    <div className={styles.tableWrapper}>

    <Label 
          topText={title}
          bottomText={subtitle}
          shift="large"
          />
      
      <div className={styles.buttonsRow}>
        <h2>Ширина:</h2>
        <div className={styles.buttons}>
          <button 
            className={`${styles.button} ${selectedWidth === '12м' ? styles.buttonActive : ''}`} 
            onClick={() => onWidthChange('12м')}
          >
            12м
          </button>
          <button 
            className={`${styles.button} ${selectedWidth === '15м' ? styles.buttonActive : ''}`}
            onClick={() => onWidthChange('15м')}
          >
            15м
          </button>
          <button 
            className={`${styles.button} ${selectedWidth === '18м' ? styles.buttonActive : ''}`}
            onClick={() => onWidthChange('18м')}
          >
            18м
          </button>
          <button 
            className={`${styles.button} ${selectedWidth === '21м' ? styles.buttonActive : ''}`}
            onClick={() => onWidthChange('21м')}
          >
            21м
          </button>
          <button 
            className={`${styles.button} ${selectedWidth === '24м' ? styles.buttonActive : ''}`}
            onClick={() => onWidthChange('24м')}
          >
            24м
          </button>
        </div>
      </div>
      {warning && <p className={styles.warning}>{warning}</p>}
      
      
      <div className={styles.tableContainer}>
        
        <table className={styles.priceTable}>
          <thead>
            <tr>
              <th className={styles.headerCell} rowSpan="2">Виды работ</th>
              <td className={styles.subHeaderCell} colSpan={data.columns.length}>
                {data.subHeader}
              </td>
            </tr>
            <tr>
              {data.columns.map((length) => (
                <th key={length} className={styles.headerCell}>
                  {length}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {/* Основные строки */}
            {data.rows.map((row, index) => (
              <tr key={index} className={styles.tableRow}>
                <td className={styles.nameCell}>
                  <div className={styles.nameCellWrapper}>
                    {row.name}
                    {row.clue && (
                      <div className={styles.helpIcon}>
                        ?
                        <div className={styles.tooltip}>
                          {row.clue}
                        </div>
                      </div>
                    )}
                  </div>
                </td>
                {row.prices.map((price, idx) => (
                  <td key={idx} className={styles.priceCell}>
                    {price.toLocaleString('ru-RU')}
                  </td>
                ))}
              </tr>
            ))}
            
            {/* Итоговая строка */}
            <tr className={styles.totalRow}>
              <td className={styles.nameCell}>ИТОГО</td>
              {data.totals.sum.map((sum, idx) => (
                <td key={idx} className={styles.priceCell}>
                  {sum.toLocaleString('ru-RU')}
                </td>
              ))}
            </tr>
            
            {/* Цена за м2 */}
            <tr className={styles.pricePerMeterRow}>
              <td className={styles.nameCell}>Цена за м2</td>
              {data.totals.pricePerM2.map((price, idx) => (
                <td key={idx} className={styles.priceCell}>
                  {price.toLocaleString('ru-RU')}
                </td>
              ))}
            </tr>
            
            {/* Площадь */}
            <tr className={styles.areaRow}>
              <td className={styles.nameCell}>Итого площадь, в м2</td>
              {data.totals.area.map((area, idx) => (
                <td key={idx} className={styles.priceCell}>
                  {area}
                </td>
              ))}
            </tr>
          </tbody>
        </table>
      </div>
      <div className={styles.buttonRow}>
          <p>{infoText}</p>
          <Button 
              text={buttonText} 
              onClick={handleOrderClick} 
              type="primary"
            />
        </div>
    </div>
  );
};

BuildingPriceTable.propTypes = {
  data: PropTypes.shape({
    columns: PropTypes.arrayOf(PropTypes.number).isRequired,
    rows: PropTypes.arrayOf(
      PropTypes.shape({
        name: PropTypes.string.isRequired,
        prices: PropTypes.arrayOf(PropTypes.number).isRequired,
        clue: PropTypes.string
      })
    ).isRequired,
    totals: PropTypes.shape({
      sum: PropTypes.arrayOf(PropTypes.number).isRequired,
      pricePerM2: PropTypes.arrayOf(PropTypes.number).isRequired,
      area: PropTypes.arrayOf(PropTypes.number).isRequired
    }).isRequired
  }).isRequired,
  title: PropTypes.string,
  warning: PropTypes.string,
  onWidthChange: PropTypes.func.isRequired,
  selectedWidth: PropTypes.string.isRequired,
};

export default BuildingPriceTable;